// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'

// 引入vuex
import Vuex from 'vuex'
import store from './vuex'
// 引入ele
import ElementUI from 'element-ui'
import Cookies from 'js-cookie'
import 'element-ui/lib/theme-chalk/index.css'
import 'element-ui/lib/theme-chalk/display.css'
import elementUtils from 'vue-element-utils'
/* 全局fliter */
import * as commonFliter from './common/filters'
import elDragDialog from './common/el-drag-dialog'
// 添加标签事件绑定 可以放大移动弹窗
Vue.directive('dragDialog', elDragDialog)
Object.keys(commonFliter).forEach(key => {
  Vue.filter(key, commonFliter[key])
})
// 全局修改默认配置，点击空白处不能关闭弹窗
ElementUI.Dialog.props.closeOnClickModal.default = false
Vue.config.productionTip = false

// use
Vue.use(Vuex)
Vue.use(ElementUI)
Vue.use(elementUtils)

// 全局注册自定义指令，用于判断当前图片是否能够加载成功，可以加载成功则赋值为img的src属性，否则使用默认图片
Vue.directive('real-img', async function (el, binding) {
  // 获取图片地址
  let imgURL = binding.value
  // 获取默认图片地址
  let defaultURL = el.getAttribute('default-img')
  if (imgURL) {
    let exist = await commonFliter.imageIsExist(imgURL)
    if (exist) {
      el.setAttribute('src', imgURL)
    } else {
      if (defaultURL) {
        el.setAttribute('src', defaultURL)
      }
    }
  }
})

// 滚动条滚到最顶端和最左端
Vue.prototype.gotoTop = function () {
  let tb = document.querySelector('.el-table__body-wrapper')
  if (tb) {
    tb.scrollTo(0, 0)
  }
  let r = document.querySelector('.right-box')
  if (r) {
    r.scrollTo(0, 0)
  }
}

/* 路由处理 */
router.beforeEach((to, from, next) => {
  // 匹配前往的路由不存在
  if (to.matched.length === 0) {
    // 判断此跳转路由的来源路由是否存在，存在的情况跳转到来源路由，否则跳转到404页面
    from.path ? next(from.path) : next({name: 'error', params: { err: '404' }})
  } else {
    let key = to.meta.key
    if (key) {
      store.dispatch('getUserInfo', {}).then(response => {
        if (response.data === '' || JSON.stringify(response.data) === '{}') {
          if (to.path !== '/login') {
            return next('/login')
          }
          next()
        } else {
          store.commit('USER_INFO', response.data)
          if (response.errno === 0 && response.data && response.data.Apps && response.data.Apps.length > 0) {
            let curAppId = Cookies.get('appid')
            if (!curAppId) {
              curAppId = response.data.Apps[0]['appid'].toString()
              Cookies.set('appid', curAppId)
            }
            for (let i = 0; i < response.data.Apps.length; i++) {
              if (response.data.Apps[i]['appid'].toString() === curAppId) {
                store.commit('CURRENT_APP', response.data.Apps[i])
                window.setTimeout(function () {
                  document.title = to.meta.zhName.replace('Channel', store.state.channel.currentChannel.channelname) + '_' + store.state.common.app.appname + '网站管理系统'
                }, 1000)
              }
            }
          }
          next()
        }
      })
    } else {
      next({path: to.path})
    }
  }
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})
